import React, { FC } from 'react'
import {
  EmptyState,
  GaugeCount,
  GaugeInfo,
  GaugeRing,
  GaugeRingInner,
  GaugeRow,
  GaugeTitle,
  GaugesWrap,
} from './styles'

export interface RecurrenceBucket {
  novos: number
  recorrentes: number
  percentualNovos: number
  percentualRecorrentes: number
}

const Gauge: FC<{ pct: number; color: string; label: string; count: number }> = ({
  pct,
  color,
  label,
  count,
}) => (
  <GaugeRow>
    <GaugeRing
      style={{ background: `conic-gradient(${color} ${(pct || 0) * 3.6}deg, #E5E7EB 0deg)` }}
    >
      <GaugeRingInner>{Math.round(pct || 0)}%</GaugeRingInner>
    </GaugeRing>
    <GaugeInfo>
      <GaugeTitle>{label}</GaugeTitle>
      <GaugeCount>{Number(count || 0).toLocaleString('pt-BR')}</GaugeCount>
    </GaugeInfo>
  </GaugeRow>
)

/** Recorrência: dois medidores em anel (novos vs recorrentes). */
const RecurrenceGauges: FC<{ bucket?: RecurrenceBucket }> = ({ bucket }) => {
  if (!bucket) {
    return <EmptyState>Sem dados no período selecionado.</EmptyState>
  }

  return (
    <GaugesWrap>
      <Gauge
        pct={bucket.percentualNovos}
        color="#98A2B3"
        label="Novos clientes"
        count={bucket.novos}
      />
      <Gauge
        pct={bucket.percentualRecorrentes}
        color="#101828"
        label="Clientes recorrentes"
        count={bucket.recorrentes}
      />
    </GaugesWrap>
  )
}

export default RecurrenceGauges
